import React from "react";
import type { EditableOrderField } from "../types";
import { useTranslation } from "react-i18next";

interface FieldSelectionPopupProps {
    position: { top: number; left: number };
    onFieldValueSelected: (field: EditableOrderField, value: string) => void;
    selectedText: string;
    onClose: () => void;
}

const FieldSelectionPopup: React.FC<FieldSelectionPopupProps> = ({ position, onFieldValueSelected, selectedText, onClose }) => {
    const { t } = useTranslation();

    const handleClick = (field: EditableOrderField) => {
        onFieldValueSelected(field, selectedText);
    };

    return (
        <div
            style={{
                position: "absolute",
                top: position.top,
                left: position.left,
                background: "white",
                border: "1px solid #ccc",
                padding: "10px",
                borderRadius: "4px",
                zIndex: 1000,
                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                ...(window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
                    ? {
                        background: "#2b2b2b",
                        color: "#fff",
                        border: "1px solid #555",
                    }
                    : {}),
                display: "flex",
                flexDirection: "column", // stack buttons vertically
                gap: "6px", // adds spacing between buttons
            }}


        >
            <button onClick={() => {
                navigator.clipboard.writeText(selectedText);
                onClose(); 
            }}
                style={{ color: "inherit", background: "none", border: "none", cursor: "pointer" }}>{t("Copy")}</button>
            <button onClick={() => handleClick("ata")}
                style={{ color: "inherit", background: "none", border: "none", cursor: "pointer" }}>{t("ATA")}</button>
            <button onClick={() => handleClick("customerNumber")}
                style={{ color: "inherit", background: "none", border: "none", cursor: "pointer" }}>{t("Customer Reference Number")}
                </button>
            <button onClick={() => handleClick("containerNumber")}
                style={{ color: "inherit", background: "none", border: "none", cursor: "pointer" }}>{t("Container number")}
            </button>
            <button onClick={() => handleClick("notes")}
                style={{ color: "inherit", background: "none", border: "none", cursor: "pointer" }}>{t("Notes")}
            </button>
            <button onClick={() => handleClick("positionsNumber")}
                style={{ color: "inherit", background: "none", border: "none", cursor: "pointer" }}>{t("Position number")}
            </button>
            <button onClick={() => handleClick("atc")}
                style={{ color: "inherit", background: "none", border: "none", cursor: "pointer" }}>{t("ATC")}
            </button>
            <button onClick={() => handleClick("mrn")}
                style={{ color: "inherit", background: "none", border: "none", cursor: "pointer" }}>{t("MRN")}
            </button>
        </div>
    );
};

export default FieldSelectionPopup;
